import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=cd851766&"
import script from "./DropArea.vue?vue&type=script&lang=ts&"
export * from "./DropArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports